module.exports = __webpack_public_path__ + "img/homeImage3.1456463.svg";